import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { isNonEmptyString } from 'ts-utils';
import { Color } from '../../config/Color';
import { appOverride } from '../../util/AppUtils';
import { QuestionMarkColorable } from '../assets/icons';
import { BodyXXS } from './Typography';

export type InfoBoxProps = {
  titleText?: string;
  bodyText: string;
};

export function InfoBox(props: InfoBoxProps): ReactElement {
  return (
    <InfoBoxContainer>
      {isNonEmptyString(props.titleText) && (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ paddingRight: 10 }}>
            <QuestionMarkColorable color={'#6FB1A0'} />
          </div>
          <BodyXXS
            style={{
              height: 26,
              alignContent: 'center',
              fontWeight: 500,
              lineHeight: '24px',
            }}
          >
            {props.titleText}
          </BodyXXS>
        </div>
      )}
      <BodyXXS style={{ margin: 'auto', textAlign: 'left', lineHeight: '24px' }}>
        {props.bodyText}
      </BodyXXS>
    </InfoBoxContainer>
  );
}

const InfoBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${appOverride({ nerva: '24px', default: '8px' })};
  background-color: ${Color.surface.muted};
  border: 2px solid ${appOverride({ nerva: 'transparent', default: Color.decorative.default })};
  margin: ${appOverride({ nerva: '16px 0', default: '16px' })};
  padding: 16px;
  width: ${appOverride({ nerva: '100%', default: 'auto' })};
  box-sizing: border-box;
`;
